import PropTypes from 'prop-types';
import { classes } from '@/helpers/styling';

const ScrollingContent = ({
  wrapperRef,
  contentRef,
  wrapperStyle,
  contentStyle,
  children,
  centered,
  ...props
}) => {
  return (
    <div
      className={ classes('scrolling-wrapper', { '--is-centered': centered }) }
      ref={ wrapperRef }
      style={ wrapperStyle }
    >
      <div
        className='scrolling-content'
        ref={ contentRef }
        style={ contentStyle }
        { ...props }
      >
        { children }
      </div>
    </div>
  );
};

ScrollingContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  wrapperRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object
  ]),
  contentRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object
  ]),
  wrapperStyle: PropTypes.object,
  contentStyle: PropTypes.object,
  centered: PropTypes.bool
};

ScrollingContent.defaultProps = {
  wrapperRef: undefined,
  contentRef: undefined,
  wrapperStyle: {},
  contentStyle: {},
  centered: false
};

export default ScrollingContent;